import Box from '@liquidweb-dev/undercurrent/Box';
import Button, { type ButtonProps } from '@liquidweb-dev/undercurrent/Button';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import LogoText from 'components/standard/LWLogoText/LWLogoText';
import { useLogout } from 'modules/oidc/useLogout';
import useAccountDetails from 'modules/queries/account/useDetails';

export interface TerminatedProps {
	logoutButtonProps?: Omit<ButtonProps, 'size'>;
}

const Terminated = ({ logoutButtonProps }: TerminatedProps) => {
	const logout = useLogout();
	const { data: accountDetails } = useAccountDetails({});

	const accountNumber = accountDetails?.accnt;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<LogoText />

			<Box sx={{ display: 'flex', alignItems: 'center', gap: 100 }}>
				<Typography variant="body-sm">Account # {accountNumber}</Typography>
				<Button
					variant="link"
					onClick={logout}
					size="large"
					{...logoutButtonProps}
				>
					Logout
				</Button>
			</Box>
		</Box>
	);
};

export default Terminated;
